<header class="topbar">
  <div class="topbar__left">
    <!-- Breadcrumb -->
    <nav class="topbar__breadcrumb">
      <a routerLink="/dashboard" class="topbar__bc-link">Invento Rating</a>
      <span class="topbar__bc-sep">›</span>
      <span class="topbar__bc-current">Dashboard</span>
    </nav>
  </div>

  <div class="topbar__center">
    <!-- Global Search -->
    <div class="topbar__search">
      <svg class="topbar__search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input
        class="topbar__search-input"
        type="text"
        placeholder="Search lines of business, variables, tables... (⌘K)"
        readonly
      />
      <kbd class="topbar__search-kbd">⌘K</kbd>
    </div>
  </div>

  <div class="topbar__right">
    <!-- AI Assistant -->
    <button class="topbar__btn topbar__ai-btn" title="AI Assistant">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
      </svg>
      <span>AI Assist</span>
    </button>

    <!-- Theme Toggle -->
    <button class="topbar__btn topbar__icon-btn" (click)="themeService.toggle()" [title]="themeService.currentTheme() === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'">
      @if (themeService.currentTheme() === 'dark') {
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="5"></circle>
          <line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
          <line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
        </svg>
      } @else {
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
      }
    </button>

    <!-- Notifications -->
    <button class="topbar__btn topbar__icon-btn topbar__notif-btn" title="Notifications">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
      </svg>
      @if (notifService.unreadCount() > 0) {
        <span class="topbar__notif-dot">{{ notifService.unreadCount() }}</span>
      }
    </button>

    <!-- Help -->
    <button class="topbar__btn topbar__icon-btn" title="Help & Documentation">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
    </button>

    <!-- Settings -->
    <button class="topbar__btn topbar__icon-btn" title="Settings" [routerLink]="['/settings']">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
      </svg>
    </button>

    <!-- Profile -->
    <div class="topbar__profile" (click)="$event.stopPropagation()">
      <button
        class="topbar__btn topbar__profile-btn"
        [class.is-open]="showProfileMenu"
        title="Profile"
        (click)="toggleProfileMenu($event)"
      >
        <span class="topbar__avatar">{{ user().initials }}</span>
        <span class="topbar__profile-name">{{ user().name }}</span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>

      @if (showProfileMenu) {
        <div class="topbar__profile-menu">
          <div class="topbar__profile-head">
            <span class="topbar__avatar topbar__avatar--large">{{ user().initials }}</span>
            <div>
              <strong>{{ user().name }}</strong>
              <small>{{ user().email }}</small>
            </div>
          </div>

          <button class="topbar__menu-item" (click)="onMenuAction('profile')">My Profile</button>
          <button class="topbar__menu-item" (click)="onMenuAction('security')">Security</button>
          <button class="topbar__menu-item" (click)="onMenuAction('preferences')">Preferences</button>
          <div class="topbar__menu-divider"></div>
          <button class="topbar__menu-item topbar__menu-item--danger" (click)="onMenuAction('logout')">
            Log Out
          </button>
        </div>
      }
    </div>
  </div>
</header>
